import { GraphConfig, GraphType } from "@src/features/analytics/types";

export const rolloutGraphConfig: GraphConfig[] = [
  {
    title: ["Conversion Rate"],
    metrics: ["conversion_rate"],
    canBeKeyMetric: true,
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasAudience: true,
    hasImpactCalculation: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
    isInverted: false,
  },
  {
    title: ["Revenue per Visitor"],
    metrics: [
      "net_revenue_per_visitor",
      "net_revenue",
      "n_orders",
      "n_visitors",
    ],
    canBeKeyMetric: true,
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasAudience: true,
    hasImpactCalculation: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
    isInverted: false,
  },
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor", "net_revenue"],
    canBeKeyMetric: true,
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasAudience: true,
    hasImpactCalculation: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
    isInverted: false,
  },
  {
    title: ["Average Order Value"],
    metrics: ["net_revenue_per_order"],
    canBeKeyMetric: true,
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedBar,
    hasAudience: true,
    hasImpactCalculation: false,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    isImpactGraph: true,
    isInverted: false,
  },
];

export const newOverviewGraphConfig: GraphConfig[] = [];

export const newProfitGraphConfig: GraphConfig[] = [
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,
    hasValueCI: true,
    hasProbability: true,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: true,
  },
  {
    title: ["Product Revenue"],
    metrics: ["net_product_revenue"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total COGS"],
    metrics: ["total_cogs"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Product Profit"],
    metrics: ["product_profit"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Shipping Revenue"],
    metrics: ["net_shipping_revenue"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Shipping Cost"],
    metrics: ["total_shipping_cost"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Shipping Profit"],
    metrics: ["shipping_profit"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Transaction Fees"],
    metrics: ["total_transaction_fee"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total Tax Included"],
    metrics: ["total_tax_included"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Net Revenue"],
    metrics: ["net_revenue"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total Cost"],
    metrics: ["total_cost"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Total Profit"],
    metrics: ["gross_profit"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["% Gross Margin"],
    metrics: ["gross_margin_pct"],
    datasetId: "variation_overview",
    dataTypes: ["percentTwoDecimal"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
  {
    title: ["Visitors"],
    metrics: ["n_visitors"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: false,
    canBeKeyMetric: false,
  },
  {
    title: ["Orders"],
    metrics: ["n_orders"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: false,
    hasProbability: false,
    hasTimeseries: true,
    hasAudience: false,
    canBeKeyMetric: false,
  },
  {
    title: ["Profit per Order"],
    metrics: ["gross_profit_per_order"],
    datasetId: "variation_overview",
    dataTypes: ["number"],
    graphType: GraphType.Table,

    hasValueCI: true,
    hasProbability: true,
    hasTimeseries: true,
    hasAudience: true,
    canBeKeyMetric: false,
  },
];

export const newCustomMetricsGraphConfig: GraphConfig[] = [];

export const newDataReconciliationGraphConfig: GraphConfig[] = [
  {
    title: [""],
    metrics: [
      "n_sessions",
      "n_visitors",
      "n_orders",
      "net_revenue",
      "net_revenue_per_visitor",
      "gross_profit_per_visitor",
      "net_product_revenue",
      "total_cogs",
      "product_profit",
      "net_shipping_revenue",
      "total_shipping_cost",
      "shipping_profit",
      "total_transaction_fee",
      "total_tax_included",
      "total_cost",
      "gross_profit",
      "gross_profit_per_order",
      "conversion_rate",
      "net_product_revenue_per_order",
      "net_shipping_revenue_per_order",
      "avg_units_per_order",
      "add_to_cart_rate",
      "checkout_begin_rate",
      "avg_product_revenue_per_unit",
    ],
    dataTypes: ["currency"],
    datasetId: "order_reconciliation",
    graphType: GraphType.Bar,
    isImpactGraph: true,

    canBeKeyMetric: true,
    hasProbability: false,
    hasTimeseries: true,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
];

export const newShippingGraphConfig: GraphConfig[] = [
  {
    title: ["Shipping Revenue per Order"],
    metrics: [
      "net_shipping_revenue_per_order",
      "n_visitors",
      "n_orders",
      "net_revenue",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,

    canBeKeyMetric: true,
    hasProbability: false,
    hasTimeseries: true,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["% of Orders with Free Shipping"],
    metrics: ["pct_orders_free_shipping"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: true,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: true,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Order Value Distribution"],
    metrics: ["n_orders_free_shipping"],
    dataTypes: ["currency"],
    datasetId: "variation_shipping_method",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: ["Cumulative % of Orders"],
    metrics: [
      "n_orders_free_shipping",
      "pct_orders_free_shipping",
      "net_shipping_revenue_per_order",
      "total_shipping_cost",
      "shipping_profit",
      "n_visitors",
      "n_orders",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_shipping_method",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },

  {
    title: [""],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_shipping_method",
    filterMetric: "shipping_method",
    graphType: GraphType.Bar,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: [""],
    metrics: ["net_shipping_revenue_per_order"],
    dataTypes: ["currency"],
    filterMetric: "shipping_method",
    datasetId: "variation_shipping_method",
    graphType: GraphType.Bar,

    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: ["Net Shipping Revenue"],
    metrics: ["net_shipping_revenue"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
];

export const newConversionGraphConfig: GraphConfig[] = [
  {
    title: ["View Collection Rate"],
    isImpactGraph: true,
    metrics: ["view_collection_page_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["View Product Rate"],
    isImpactGraph: true,
    metrics: ["view_product_page_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["ATC Rate"],
    isImpactGraph: true,
    metrics: ["add_to_cart_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Abandoned Cart Rate"],
    isImpactGraph: true,
    metrics: ["abandoned_cart_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
    isInverted: true,
  },
  {
    title: ["Begin Checkout Rate"],
    isImpactGraph: true,
    metrics: ["checkout_begin_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Abandoned Checkout Rate"],
    isImpactGraph: true,
    metrics: ["abandoned_checkout_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
    isInverted: true,
  },
  {
    title: ["Conversion Rate"],
    isImpactGraph: true,
    metrics: ["conversion_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    canBeKeyMetric: true,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },

  {
    filterMetric: "dt",

    title: [""],
    metrics: [
      "conversion_rate",
      "add_to_cart_rate",
      "checkout_begin_rate",
      "checkout_enter_contact_info_rate",
      "checkout_address_submitted_rate",
      "view_product_page_rate",
      "view_collection_page_rate",
      "n_visitors",
      "n_visitors_ordered",
      "gross_profit_per_visitor",
      "net_revenue_per_visitor",
      "abandoned_cart_rate",
      "n_visitors_abandoned_cart",
      "abandoned_checkout_rate",
      "n_visitors_abandoned_checkout",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Sankey,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
  },
  {
    title: [],
    isImpactGraph: true,
    metrics: [
      "n_visitors_added_to_cart",
      "n_visitors_checkout_started",
      "n_visitors_abandoned_cart",
      "n_visitors_abandoned_checkout",
      "n_visitors_checkout_contact_info_submitted",
      "n_visitors_checkout_address_info_submitted",
      "n_visitors_viewed_product_page",
      "n_visitors_viewed_collection_page",
    ],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    canBeKeyMetric: false,
    hasProbability: false,
    hasTimeseries: false,
    hasValueCI: false,
    hasAudience: false,
    hasImpactCalculation: false,
  },
];
export const newRevenueGraphConfig: GraphConfig[] = [
  {
    title: ["Revenue per Visitor"],
    metrics: ["net_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    isImpactGraph: true,
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["AOV (Net Revenue per Order)"],
    metrics: [
      "net_product_revenue_per_order",
      "net_shipping_revenue_per_order",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedBar,
    isImpactGraph: true,
    stackedBarLegendTitles: ["Product AOV", "Shipping AOV"],

    showSumStackedLabels: true,
    hasTimeseries: false,
    canBeKeyMetric: true,
    hasProbability: false,
    hasAudience: false,
    hasValueCI: false,
    impactMetric: "net_revenue_per_order",
    hasImpactCalculation: false,
  },
  {
    title: ["Net Product Revenue per Order"],
    metrics: ["net_product_revenue_per_order"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Net Shipping Revenue per Order"],
    metrics: ["net_shipping_revenue_per_order"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Avg Units per Order"],
    metrics: ["avg_units_per_order"],
    dataTypes: ["number"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Avg Product Revenue per Unit"],
    metrics: ["avg_product_revenue_per_unit"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Total Avg Order Value"],
    metrics: ["net_revenue_per_order"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    isImpactGraph: false,

    showSumStackedLabels: false,
    canBeKeyMetric: false,
    hasProbability: true,
    hasTimeseries: true,
    hasValueCI: true,
    hasAudience: true,
  },
  {
    title: ["Net Shipping Revenue"],
    metrics: ["net_shipping_revenue"],
    dataTypes: ["currency"],
    isImpactGraph: true,
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
];

export const newDiscountGraphConfig: GraphConfig[] = [
  {
    title: ["% of Orders with Discount"],
    metrics: ["pct_discounted_orders"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    canBeKeyMetric: false,
    hasTimeseries: true,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Avg Discount"],
    metrics: [
      "avg_discount_per_discounted_order",
      "avg_discount_per_all_orders",
    ],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasTimeseries: true,
    hasAudience: true,
    hasMetricFilterIndex: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Discount % of Gross Revenue"],
    metrics: [
      "discount_pct_discounted_order_gross_revenue",
      "discount_pct_total_gross_revenue",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    showSumStackedLabels: true,
    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasTimeseries: true,
    hasAudience: true,
    hasMetricFilterIndex: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Discount % of Gross Profit"],
    metrics: [
      "discount_pct_discounted_order_gross_profit",
      "discount_pct_total_gross_profit",
    ],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: true,
    hasTimeseries: true,
    hasMetricFilterIndex: true,
    hasImpactCalculation: false,
  },
  {
    title: ["# of Orders w/ a Discount"],
    filterMetric: "variation_id",
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,
    hasTimeseries: true,
    hasProbability: false,
    hasValueCI: false,
    canBeKeyMetric: false,
    hasAudience: true,
  },
  {
    title: [""],
    metrics: ["n_visitors", "n_orders", "net_revenue"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasTimeseries: false,
    hasProbability: false,
    hasValueCI: false,
    canBeKeyMetric: false,
    hasAudience: false,
  },
  {
    title: ["Number Orders Discounted"],
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    hasTimeseries: false,
    hasProbability: false,
    hasValueCI: false,
    canBeKeyMetric: false,
    hasAudience: false,
  },
];

export const newSubscriptionsGraphConfig: GraphConfig[] = [
  {
    title: ["Subscription Orders per Visitor"],
    metrics: ["subscription_orders_per_visitor"],
    dataTypes: ["number"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Subscription Revenue per Visitor"],
    metrics: ["subscription_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Subscription Profit per Visitor"],
    metrics: ["subscription_gross_profit_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: true,
  },
  {
    title: ["Subscription % of Orders"],
    metrics: ["pct_subscription_orders"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: false,
    hasTimeseries: true,
    canBeKeyMetric: false,
    hasValueCI: false,
    hasAudience: true,
  },
  {
    title: ["Subscription AOV"],
    metrics: [
      "subscription_product_revenue_per_order",
      "subscription_shipping_revenue_per_order",
    ],
    dataTypes: ["currency"],
    stackedBarLegendTitles: ["Product AOV", "Shipping AOV"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedBar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: false,
    canBeKeyMetric: true,
    hasValueCI: false,
    hasAudience: false,
    impactMetric: "subscription_revenue_per_order",
    hasImpactCalculation: false,
  },
  {
    title: ["Subscription Avg Units per Order"],
    metrics: ["subscription_units_per_subscription_order"],
    dataTypes: ["number"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    showSumStackedLabels: true,
    isImpactGraph: true,
    canBeKeyMetric: true,
    hasAudience: true,
    hasTimeseries: true,
    hasProbability: true,
    hasValueCI: true,
  },
  {
    title: ["Subscription Product Revenue per Unit"],
    metrics: ["subscription_product_revenue_per_unit"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: [""],
    metrics: ["n_orders", "net_revenue"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: false,
    hasProbability: false,
    hasTimeseries: false,
    canBeKeyMetric: false,
    hasValueCI: false,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Number of Subscription Orders"],
    metrics: ["n_subscription_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Subscription Shipping Revenue"],
    metrics: ["subscription_shipping_revenue"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Number of Subscription Units"],
    metrics: ["subscription_units"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
  {
    title: ["Number of Subscription Units"],
    metrics: ["subscription_product_revenue"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Bar,

    isImpactGraph: true,
    hasProbability: true,
    hasTimeseries: true,
    canBeKeyMetric: true,
    hasValueCI: true,
    hasAudience: true,
    hasImpactCalculation: false,
  },
];

export const newProductGroupsGraphConfig: GraphConfig[] = [
  {
    title: ["Product Group Mix"],
    filterMetric: "product_group",
    metrics: ["pct_total_revenue", "pct_total_units"],
    dataTypes: ["number"],
    datasetId: "variation_product_groups",
    graphType: GraphType.StackedBarHorizontal,

    maxGroupAmt: 9,
    hasMetricFilterIndex: true,
  },
  {
    title: ["Product Group Detail"],
    filterMetric: "variation_id",
    metrics: ["net_product_revenue_per_order"],
    dataTypes: ["number"],
    datasetId: "variation_product_groups",
    graphType: GraphType.Table,
  },
  {
    title: ["Product Group Detail"],
    filterMetric: "variation_id",
    metrics: ["net_product_revenue", "add_to_cart_rate", "n_orders"],
    dataTypes: ["number"],
    datasetId: "variation_products",
    graphType: GraphType.Table,
  },
];

export const newOrdersGraphConfig: GraphConfig[] = [
  {
    title: ["Orders Over Time"],

    filterMetric: "dt",
    metrics: ["n_visitors"],
    dataTypes: ["none"],
    datasetId: "variation_overview",
    graphType: GraphType.StackedArea,

    showSumStackedLabels: true,
  },
];

export const ordersAdvancedGraphConfig: GraphConfig[] = [
  {
    title: ["% Orders by Unit Quantity"],
    filterMetric: "unit_quantity",
    metrics: ["pct_orders_by_unit_quantity"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_order_unit_mix",
    graphType: GraphType.StackedBarHorizontal,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    maxGroupAmt: 6,
  },
  {
    title: ["% Net Revenue by Order Unit Quantity"],
    filterMetric: "unit_quantity",
    metrics: ["pct_revenue_by_unit_quantity"],
    dataTypes: ["percentNoDecimal"],
    datasetId: "variation_order_unit_mix",
    graphType: GraphType.StackedBarHorizontal,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    maxGroupAmt: 6,
  },
  {
    title: [""],
    filterMetric: "variation_id",
    metrics: ["total_units"],
    dataTypes: ["number"],
    datasetId: "variation_histogram",
    graphType: GraphType.Histogram,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    histogramBucket: "bin",
  },
  {
    title: ["Order Value Distribution"],
    metrics: [],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_histogram",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    hasKDE: true,
    hasCDF: false,
  },
  {
    title: ["Cumulative % of Orders"],
    metrics: [],
    dataTypes: ["percent"],
    datasetId: "variation_histogram",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    hasKDE: false,
    hasCDF: true,
  },
  {
    title: ["Orders Over Time"],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.StackedArea,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    filterMetric: "dt",
  },
  {
    title: ["Order Value Distribution"],
    metrics: [""],
    dataTypes: ["percent"],
    datasetId: "variation_histogram",
    graphType: GraphType.Line,

    canBeKeyMetric: false,
    hasProbability: false,
    hasValueCI: false,
    hasAudience: false,
    hasTimeseries: false,
    hasKDE: true,
    showLegend: true,
  },
];

export const newPersonalizationBaseGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders"],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Visitors"],
    metrics: ["n_visitors"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",
  },
  {
    title: ["Conversion Rate"],
    metrics: ["conversion_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,

    hasAudience: true,
  },
  {
    title: ["Total Average Order Value"],
    metrics: ["net_revenue_per_order"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,

    hasAudience: true,
  },
  {
    title: ["Revenue per Visitor"],
    metrics: ["net_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Total Revenue"],
    metrics: ["net_revenue"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    hasAudience: true,
  },

  {
    title: ["Total Profit"],
    metrics: ["gross_profit"],
    dataTypes: ["currencyNoDecimal"],

    datasetId: "variation_overview",
    graphType: GraphType.Line,

    hasAudience: true,
  },
];

export const newPersonalizationTimeSeriesGraphsConfig: GraphConfig[] = [
  {
    title: ["Visitors"],
    metrics: ["n_visitors"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Orders"],
    metrics: ["n_orders"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Conversion Rate"],
    metrics: ["conversion_rate"],
    dataTypes: ["percentTwoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,

    showSumMetric: true,
    filterMetric: "dt",
  },
  {
    title: ["Total Average Order Value"],
    metrics: ["net_revenue_per_order"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Revenue per Visitor"],
    metrics: ["net_revenue_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Profit per Visitor"],
    metrics: ["gross_profit_per_visitor"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Total Revenue"],
    metrics: ["net_revenue"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },

  {
    title: ["Total Profit"],
    metrics: ["gross_profit"],
    dataTypes: ["currencyNoDecimal"],

    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
];

export const newPersonalizationTimeseriesOfferGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders Discounted"],
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["% of Orders Discounted"],
    metrics: ["pct_discounted_orders"],
    dataTypes: ["percent"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Total Discount Offered"],
    metrics: ["total_discount"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Discount % of Revenue (pre-discount)"],
    metrics: ["discount_pct_total_gross_revenue"],
    dataTypes: ["percent"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Discount % Profit"],
    metrics: ["discount_pct_total_gross_profit"],
    dataTypes: ["percent"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Avg Discount"],
    metrics: ["avg_discount_per_all_orders"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Avg Discount (discounted orders)"],
    metrics: ["avg_discount_per_discounted_order"],
    dataTypes: ["currency"],
    datasetId: "variation_timeseries_discrete",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
];

export const newPersonalizationOfferGraphsConfig: GraphConfig[] = [
  {
    title: ["Orders Discounted"],
    metrics: ["n_orders_discounted"],
    dataTypes: ["numberNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["% of Orders Discounted"],
    metrics: ["pct_discounted_orders"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Total Discount Offered"],
    metrics: ["total_discount"],
    dataTypes: ["currencyNoDecimal"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Discount % of Gross Revenue"],
    metrics: ["discount_pct_total_gross_revenue"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Discount % of Gross Profit"],
    metrics: ["discount_pct_total_gross_profit"],
    dataTypes: ["percent"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Avg Discount"],
    metrics: ["avg_discount_per_all_orders"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
  {
    title: ["Avg Discount (discounted orders)"],
    metrics: ["avg_discount_per_discounted_order"],
    dataTypes: ["currency"],
    datasetId: "variation_overview",
    graphType: GraphType.Line,
    filterMetric: "dt",

    showSumMetric: true,
  },
];
